import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import bowser from "bowser";
export var createDefaultUserAgentProvider = function createDefaultUserAgentProvider(_ref) {
  var serviceId = _ref.serviceId,
    clientVersion = _ref.clientVersion;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
      var _window, _window$navigator, _parsedUA$os, _parsedUA$os2, _parsedUA$browser$nam, _parsedUA$browser, _parsedUA$browser$ver, _parsedUA$browser2, _config$userAgentAppI;
      var parsedUA, sections, appId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              parsedUA = typeof window !== "undefined" && (_window = window) !== null && _window !== void 0 && (_window$navigator = _window.navigator) !== null && _window$navigator !== void 0 && _window$navigator.userAgent ? bowser.parse(window.navigator.userAgent) : undefined;
              sections = [["aws-sdk-js", clientVersion], ["ua", "2.1"], ["os/".concat((parsedUA === null || parsedUA === void 0 ? void 0 : (_parsedUA$os = parsedUA.os) === null || _parsedUA$os === void 0 ? void 0 : _parsedUA$os.name) || "other"), parsedUA === null || parsedUA === void 0 ? void 0 : (_parsedUA$os2 = parsedUA.os) === null || _parsedUA$os2 === void 0 ? void 0 : _parsedUA$os2.version], ["lang/js"], ["md/browser", "".concat((_parsedUA$browser$nam = parsedUA === null || parsedUA === void 0 ? void 0 : (_parsedUA$browser = parsedUA.browser) === null || _parsedUA$browser === void 0 ? void 0 : _parsedUA$browser.name) !== null && _parsedUA$browser$nam !== void 0 ? _parsedUA$browser$nam : "unknown", "_").concat((_parsedUA$browser$ver = parsedUA === null || parsedUA === void 0 ? void 0 : (_parsedUA$browser2 = parsedUA.browser) === null || _parsedUA$browser2 === void 0 ? void 0 : _parsedUA$browser2.version) !== null && _parsedUA$browser$ver !== void 0 ? _parsedUA$browser$ver : "unknown")]];
              if (serviceId) {
                sections.push(["api/".concat(serviceId), clientVersion]);
              }
              _context.next = 5;
              return config === null || config === void 0 ? void 0 : (_config$userAgentAppI = config.userAgentAppId) === null || _config$userAgentAppI === void 0 ? void 0 : _config$userAgentAppI.call(config);
            case 5:
              appId = _context.sent;
              if (appId) {
                sections.push(["app/".concat(appId)]);
              }
              return _context.abrupt("return", sections);
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var defaultUserAgent = createDefaultUserAgentProvider;